import { HttpInterceptorFn } from '@angular/common/http';
import { AUTH_EXCLUDED_PATHS } from '../../const';

export const basicAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const isExcluded = AUTH_EXCLUDED_PATHS.some(url => req.url.includes(url));
  if (isExcluded) {
    return next(req);
  }
  const modifiedRequest = req.clone({
    withCredentials: true,
    setHeaders: {
      'Auth-Api-NoRedirect': 'true',
    }
  });

  return next(modifiedRequest);
};
